"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = ({
  spaceSize
}) => ({
  space: {
    boxSizing: 'border-box'
  },
  none: {
    padding: 0
  },
  micro: {
    '&.left': {
      paddingLeft: spaceSize.micro
    },
    '&.right': {
      paddingRight: spaceSize.micro
    },
    '&.top': {
      paddingTop: spaceSize.micro
    },
    '&.bottom': {
      paddingBottom: spaceSize.micro
    }
  },
  xxsmall: {
    '&.left': {
      paddingLeft: spaceSize.xxsmall
    },
    '&.right': {
      paddingRight: spaceSize.xxsmall
    },
    '&.top': {
      paddingTop: spaceSize.xxsmall
    },
    '&.bottom': {
      paddingBottom: spaceSize.xxsmall
    }
  },
  xsmall: {
    '&.left': {
      paddingLeft: spaceSize.xsmall
    },
    '&.right': {
      paddingRight: spaceSize.xsmall
    },
    '&.top': {
      paddingTop: spaceSize.xsmall
    },
    '&.bottom': {
      paddingBottom: spaceSize.xsmall
    }
  },
  small: {
    '&.left': {
      paddingLeft: spaceSize.small
    },
    '&.right': {
      paddingRight: spaceSize.small
    },
    '&.top': {
      paddingTop: spaceSize.small
    },
    '&.bottom': {
      paddingBottom: spaceSize.small
    }
  },
  medium: {
    '&.left': {
      paddingLeft: spaceSize.medium
    },
    '&.right': {
      paddingRight: spaceSize.medium
    },
    '&.top': {
      paddingTop: spaceSize.medium
    },
    '&.bottom': {
      paddingBottom: spaceSize.medium
    }
  },
  large: {
    '&.left': {
      paddingLeft: spaceSize.large
    },
    '&.right': {
      paddingRight: spaceSize.large
    },
    '&.top': {
      paddingTop: spaceSize.large
    },
    '&.bottom': {
      paddingBottom: spaceSize.large
    }
  },
  xlarge: {
    '&.left': {
      paddingLeft: spaceSize.xlarge
    },
    '&.right': {
      paddingRight: spaceSize.xlarge
    },
    '&.top': {
      paddingTop: spaceSize.xlarge
    },
    '&.bottom': {
      paddingBottom: spaceSize.xlarge
    }
  },
  xxlarge: {
    '&.left': {
      paddingLeft: spaceSize.xxlarge
    },
    '&.right': {
      paddingRight: spaceSize.xxlarge
    },
    '&.top': {
      paddingTop: spaceSize.xxlarge
    },
    '&.bottom': {
      paddingBottom: spaceSize.xxlarge
    }
  },
  fullWidth: {
    width: '100%'
  },
  fullHeight: {
    height: '100%'
  }
});

exports.default = _default;